import React from 'react'
import { FaArrowRight } from "react-icons/fa";
import { Link } from 'react-router-dom';


const JoinBody = () => {
    const jobs = [
        {
            id:1,
            title: "Government Teacher",
            details: "Part time, Ibadan"
        },
        {
            id:2,
            title: "Chemistry Teacher",
            details: "Part time, Ibadan"
        },
        {
            id:3,
            title: "English Teacher",
            details: "Part time, Ibadan"
        }
    ]
  return (
    <div className='pt-[100px] md:pt-[70px]'>
        <h2 className='text-center font-semibold text-4xl text-[#161C2D] mt-12'>Why you should join us?</h2>
        <p className='text-center text-base font-normal text-[#504e4e] mt-8 mb-12'>Join Our Team at Quest-Inspire: Where Passion Meets Purpose In Education</p>
        <section className='flex sm:flex-col sm:w-[90%] w-[80%] gap-12 mx-auto'>
        <div className='flex flex-col justify-center items-center'>
        <svg width="91" height="90" viewBox="0 0 91 90" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.333984" width="90" height="90" rx="45" fill="#EBE9F6"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M62 35.6246C62 29.2954 56.8708 24.1663 50.5417 24.1663C44.2125 24.1663 39.0833 29.2954 39.0833 35.6246C39.0833 41.9538 44.2125 47.0829 50.5417 47.0829C56.8708 47.0829 62 41.9538 62 35.6246ZM32.8333 44.9996C37.4375 44.9996 41.1667 48.7288 41.1667 53.3329C41.1667 57.9371 37.4375 61.6663 32.8333 61.6663C28.2292 61.6663 24.5 57.9371 24.5 53.3329C24.5 48.7288 28.2292 44.9996 32.8333 44.9996ZM53.6667 53.3329C57.1188 53.3329 59.9167 56.1308 59.9167 59.5829C59.9167 63.035 57.1188 65.8329 53.6667 65.8329C50.2146 65.8329 47.4167 63.035 47.4167 59.5829C47.4167 56.1308 50.2146 53.3329 53.6667 53.3329Z" fill="#5146AE"/>
</svg>


            <h2 className='text-center font-semibold text-2xl my-2 text-[#161C2D]'>Personal Growth</h2>
            <p className='text-center text-[#555454]  text-base font-normal'>
            At Quest-Inspire, our teachers grow personally and professionally through trainings innovations,  mentorship, and lifelong learning..
            </p>
        </div>
        <div className='flex flex-col justify-center items-center'>
        <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="90" height="90" rx="45" fill="#EBE9F6"/>
<g clip-path="url(#clip0_1_2087)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 45C22.5 57.4268 32.5733 67.5 45 67.5C57.4268 67.5 67.5 57.4268 67.5 45C67.5 32.5733 57.4268 22.5 45 22.5C32.5733 22.5 22.5 32.5732 22.5 45ZM37.125 54V49.5H49.5C50.1213 49.5 50.625 48.9963 50.625 48.375C50.625 47.7537 50.1213 47.25 49.5 47.25L40.5 47.25C37.3934 47.25 34.875 44.7316 34.875 41.625C34.875 38.5184 37.3934 36 40.5 36H42.75V31.5H47.25V36H52.875V40.5H40.5C39.8787 40.5 39.375 41.0037 39.375 41.625C39.375 42.2463 39.8787 42.75 40.5 42.75H49.5C52.6066 42.75 55.125 45.2684 55.125 48.375C55.125 51.4816 52.6066 54 49.5 54H47.25V58.5H42.75V54H37.125Z" fill="#5146AE"/>
</g>
<defs>
<clipPath id="clip0_1_2087">
<rect width="50" height="50" fill="white" transform="translate(20 20)"/>
</clipPath>
</defs>
</svg>


            <h2 className='text-center font-semibold text-2xl my-2 text-[#161C2D]'>Competitive Salary</h2>
            <p className='text-center text-[#555454]  text-base font-normal'>
            We recognise the invaluable contributions of our teachers and offer competitive salaries commensurate with their expertise and dedication..
            </p>
        </div>
        <div className='flex flex-col justify-center items-center'>
        <svg width="91" height="90" viewBox="0 0 91 90" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.667969" width="90" height="90" rx="45" fill="#EBE9F6"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M29.7771 35.7963C27.5812 42.7202 30.1226 50.2689 36.0587 54.4551H36.0567L31.7171 64.3739C31.5764 64.6962 31.6079 65.0677 31.8007 65.3617C31.9935 65.6558 32.3217 65.8327 32.6733 65.8322H58.6525C59.0047 65.833 59.3335 65.6558 59.5264 65.3612C59.7194 65.0665 59.7503 64.6943 59.6087 64.3718L55.2692 54.4551C61.2053 50.2689 63.7467 42.7202 61.5508 35.7963C59.355 28.8724 52.9277 24.168 45.6639 24.168C38.4002 24.168 31.9729 28.8724 29.7771 35.7963ZM45.6674 49.157C41.8465 49.157 38.5145 46.5596 37.582 42.8542L41.6237 41.8438C42.0852 43.7015 43.7532 45.0058 45.6674 45.0058C47.5817 45.0058 49.2497 43.7015 49.7112 41.8438L53.7529 42.8542C52.8204 46.5596 49.4884 49.157 45.6674 49.157Z" fill="#5146AE"/>
</svg>


            <h2 className='text-center font-semibold text-2xl my-2 text-[#161C2D]'>Yearly Bonus</h2>
            <p className='text-center text-[#555454]  text-base font-normal'>
            At Quest-Inspire, our  teachers receive a token of appreciation for their dedication and contribution for their commitment to excellence and education. 
            </p>
        </div>
        </section>
        <section className='flex w-[80%] gap-12 mx-auto mt-10 mb-16'>
        <div className='flex flex-col justify-center items-center'>
        <svg width="91" height="90" viewBox="0 0 91 90" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.666016" width="90" height="90" rx="45" fill="#EBE9F6"/>
<path d="M66.3145 22.6875C59.7119 22.7158 54.8037 23.625 51.252 25.1963C48.6016 26.3682 47.5645 27.2549 47.5645 30.2588V61.75C51.624 58.0879 55.2266 57.0625 69.4395 57.0625V22.6875H66.3145ZM25.6895 22.6875C32.292 22.7158 37.2002 23.625 40.752 25.1963C43.4023 26.3682 44.4395 27.2549 44.4395 30.2588V61.75C40.3799 58.0879 36.7773 57.0625 22.5645 57.0625V22.6875H25.6895Z" fill="#5146AE"/>
</svg>


            <h2 className='text-center font-semibold text-2xl my-2 text-[#161C2D]'> Teaching Resources</h2>
            <p className='text-center text-[#555454]  text-base font-normal'>
            Teachers have access to cutting-edge teaching resources and technologies, empowering them to deliver engaging and impactful lessions.
            </p>
        </div>
        <div className='flex flex-col justify-center items-center'>
        <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="90" height="90" rx="45" fill="#EBE9F6"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M32.5007 34.5837C32.5007 41.49 38.0944 47.0837 45.0007 47.0837C51.9069 47.0837 57.5007 41.49 57.5007 34.5837C57.5007 27.6775 51.9069 22.0837 45.0007 22.0837C38.0944 22.0837 32.5007 27.6775 32.5007 34.5837ZM45.0007 49.1671C35.7959 49.1671 28.334 56.629 28.334 65.8337H61.6673C61.6673 56.629 54.2054 49.1671 45.0007 49.1671Z" fill="#5146AE"/>
</svg>


            <h2 className='text-center font-semibold text-2xl my-2 text-[#161C2D]'>Career Advancement</h2>
            <p className='text-center text-[#555454]  text-base font-normal'>
            We provide opportunities for career advancement and growth, encouraging teachers to expand their skills and take on leadership roles.
            </p>
        </div>
        <div className='flex flex-col justify-center items-center'>
        <svg width="91" height="90" viewBox="0 0 91 90" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.332031" width="90" height="90" rx="45" fill="#EBE9F6"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M29.4411 35.7963C27.2453 42.7202 29.7866 50.2689 35.7228 54.4551H35.7207L31.3811 64.3739C31.2405 64.6962 31.2719 65.0677 31.4647 65.3617C31.6576 65.6558 31.9857 65.8327 32.3374 65.8322H58.3166C58.6688 65.833 58.9976 65.6558 59.1905 65.3612C59.3834 65.0665 59.4144 64.6943 59.2728 64.3718L54.9332 54.4551C60.8694 50.2689 63.4107 42.7202 61.2149 35.7963C59.0191 28.8724 52.5918 24.168 45.328 24.168C38.0642 24.168 31.637 28.8724 29.4411 35.7963ZM45.3315 49.157C41.5105 49.157 38.1786 46.5596 37.2461 42.8542L41.2878 41.8438C41.7493 43.7015 43.4173 45.0058 45.3315 45.0058C47.2458 45.0058 48.9137 43.7015 49.3753 41.8438L53.4169 42.8542C52.4845 46.5596 49.1525 49.157 45.3315 49.157Z" fill="#5146AE"/>
</svg>


            <h2 className='text-center font-semibold text-2xl my-2 text-[#161C2D]'>Global Community </h2>
            <p className='text-center text-[#555454]  text-base font-normal'>
            By joining us, you become part of a community dedicated to making a positive impact on students lives, and  shaping the future generation 
            </p>
        </div>
        </section>
        <section className=' py-10 bg-[#F5F4FF]'>
    <h2 className='text-center text-[#454444] text-4xl font-semibold mb-6'>Current Job Openings</h2>
    <p className='text-center mb-8 text-base text-[#161C2D]'>Checkout our current job openings at Quest-Inspire. Feel free </p>
    {
        jobs.map((job, idx) =>  (
                <Link to={"/join-us/" + job.title}>
                <div className='bg-white flex justify-between w-[80%] mx-auto py-3 px-4 rounded-[16px] mb-5' key={idx}>
                <div>
                <h2>{job.title}</h2>
                <p className='mt-2'>{job.details}</p>
                </div>
                <div className='my-auto'>
<FaArrowRight />
                </div>
            </div>
                </Link>
            )
        )
    }
        </section>
    </div>
  )
}

export default JoinBody